import * as React from 'react';
import { connect } from 'react-redux';

import Comments from '../../components/Comments/Comments';
import Tabs from '../../components/Tabs/Tabs';

import * as CommentsActions from '../../actions/comments';
import * as FindUserActions from '../../actions/findUser';
import * as AuthCreators from '../../creators/auth';
import * as UserExplorerCreators from '../../creators/userExplorerFilter';
import * as userExplorerActions from '../../actions/userExplorer';
import getUserAvatar from '../../selectors/userAvatar';
import getUserFirstName from '../../selectors/getUserFirstName';
import getUserLastName from '../../selectors/getUserLastName';
import getUserCountry from '../../selectors/getUserCountry';
import getUserId from '../../selectors/getUserId';
import getUserEmail from '../../selectors/getUserEmail';
import userExplorerCurrentCategory$ from '../../selectors/userExplorerCurrentCategory';
import userExplorerDataEvents$ from '../../selectors/userExplorerDataEvents';
import NavigationTab from '../NavigationTab/NavigationTab';
import ProfileInfo from '../ProfileInfo/ProfileInfo';

import SidePannel from '../SidePannel/SidePannel';

import State from '../../interfaces/states/State';

import ExplorerCurrentCategory from '../../interfaces/ExplorerCurrentCategory';
import UserInfoResponse from '../../interfaces/UserInfoResponse';

import './style.scss';

interface DispatchProps {
  commentsBarShow: () => void;
  commentsBarHide: () => void;
  commentsValue: (value: string) => void;
  activeTabAction: (tab: number) => void;
  searchErrorInit: () => void;
  onLogout: () => void;
  currentEventActions: (category: string, checked: boolean) => void;
  userExplorerFilter: (value: string, checked: boolean) => void;
}

interface OwnProps {
  activeTab: number;
  getUserAvatar: string;
  userFirstName: string;
  userLastName: string;
  userCountry: string;
  userId: number;
  userEmail: string;
  currentCategory: ExplorerCurrentCategory;
  userExplorerisSuccess: any[];
  hideDatePicker: boolean;
  isLoading: boolean;
  userInfo: UserInfoResponse;
  isErrorWhileSearch: boolean;
}

interface Props extends DispatchProps, OwnProps {}

function UserCard (props: Props) {

  const {
    hideDatePicker,
    userExplorerisSuccess,
    userExplorerFilter,
    currentCategory,
    activeTab,
    userEmail,
    userId,
    userCountry,
    userLastName,
    userFirstName,
    isLoading,
    userInfo,
    getUserAvatar,
    onLogout,
    isErrorWhileSearch,
    searchErrorInit,
  } = props;

  return(
    <div className='d-flex user-card flex-wrap justify-center'>
      <div className='d-flex flex-column profile-wrap'>
        <ProfileInfo
          userEmail={userEmail}
          userId={userId}
          userCountry={userCountry}
          userLastName={userLastName}
          userFirstName={userFirstName}
          isLoading={isLoading}
          userInfo={userInfo}
          getUserAvatar={getUserAvatar}
        />
        <Comments />
      </div>
      <div className='nav-wrapper'>
        <NavigationTab />
        <Tabs activeTab={activeTab} />
      </div>

      <SidePannel
        nel
        searchErrorInit={searchErrorInit}
        hideDatePicker={hideDatePicker}
        userExplorerisSuccess={userExplorerisSuccess}
        userExplorerFilter={userExplorerFilter}
        currentCategory={currentCategory}
        onLogout={onLogout}
        isErrorWhileSearch={isErrorWhileSearch}
      />
    </div>
  );
}

const mapStateToProps = (state: State) => {
  return {
    activeTab: state.findUser.activeTab,
    getUserAvatar: getUserAvatar(state),
    userFirstName: getUserFirstName(state),
    userLastName: getUserLastName(state),
    userCountry: getUserCountry(state),
    userId: getUserId(state),
    userEmail: getUserEmail(state),
    currentCategory: userExplorerCurrentCategory$(state),
    userExplorerisSuccess: userExplorerDataEvents$(state),
    hideDatePicker: state.datepickers.hideDatePicker,
    isLoading: state.findUser.isLoading,
    userInfo: state.findUser.userInfo,
    isErrorWhileSearch: state.findUser.isErrorWhileSearch,
  };
};

const mergeProps = (stateProps, dispatchProps, props) => {
  return {
    ...stateProps,
    commentsBarShow: dispatchProps.commentsBarShow,
    commentsBarHide: dispatchProps.commentsBarHide,
    commentsValue: dispatchProps.commentsValue,
    activeTabAction: dispatchProps.activeTabAction,
    searchErrorInit: dispatchProps.searchErrorInit,
    onLogout: dispatchProps.onLogout,
    currentEventActions: dispatchProps.currentEventActions,
    userExplorerFilter: dispatchProps.userExplorerFilter,
    ...props,
  };
};

export default connect(
  mapStateToProps, {
    commentsBarShow: CommentsActions.fetchCommentsBarShow,
    commentsBarHide: CommentsActions.fetchCommentsBarHide,
    commentsValue: CommentsActions.fetchCommentsValue,
    activeTabAction: FindUserActions.fetchActiveTabAction,
    searchErrorInit: FindUserActions.fetchFindUserSearchErrorInit,
    onLogout: AuthCreators.onLogout,
    currentEventActions: userExplorerActions.fetchUserExplorerChangeCategoryAction,
    userExplorerFilter: UserExplorerCreators.userExplorerFilter,
  }, mergeProps
)(React.memo(UserCard));
